import styled from "@emotion/styled";
import { SMART_SIZE } from "../../../styles/common";

export const MyPageLayoutWrapper = styled.div`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  grid-template-areas:
    "header"
    "main"
    "footer";

  height: 100vh;
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
`;

export const CommonLayout = styled.div`
  grid-area: main;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  padding-left: 40px;
  padding-right: 40px;

  ${SMART_SIZE} {
    padding-left: 4%;
    padding-right: 4%;
  }
`;

export const CommonBlockBox = styled.div`
  text-align: center;
`;
